import React, { useEffect, useState } from "react";
import icon1 from "../../../assests/images/linkicon-1.png";
import icon2 from "../../../assests/images/linkicon-2.png";
import icon3 from "../../../assests/images/linkicon-3.png";
import linkIcon from "../../../assests/images/linkArrow.png";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import {
  getUserList,
  clearUserListData,
} from "../../../dependencies/services/userListServices";
import { connect } from "react-redux";
import Table from "../../common/Table";
import columns from "../dependencies/userListColumns";
import SearchBoxForUser from "../../common/SearchBoxForUser";
import { storage } from "../../../dependencies/store/storage";
import { useDispatch } from "react-redux";
import "./index.scss";
import { fetchCountData, getUserCount } from "./dependencies/action";
const FilterOption = [
  {
    text: "ALL",
    value: "ALL",
  },
  {
    text: "ADMIN",
    value: "ADMIN",
  },
  {
    text: "SUPER ADMIN",
    value: "SUPER_ADMIN",
  },
  {
    text: "EXPERT PANEL (NON FINANCIAL)",
    value: "EP_1",
  },
  {
    text: "EXPERT PANEL (FINANCIAL)",
    value: "EP_2",
  },
  {
    text: "IMB MEMBER",
    value: "IMB_MEMBER",
  },
  {
    text: "IMB CHAIR",
    value: "IMB_CHAIR",
  },
];
const UserList = (props) => {
  const { getUserList, users } = props;
  const fetchAllRecords = true;
  const [sortOrder, setSortOrder] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [selectedRole, setSelectedRole] = useState("ALL");
  const userRole = storage.getUserRole();
  const dispatch = useDispatch();
  const [userCount, setUserCount] = useState("");
  useEffect(() => {
    // getUserList({ role: selectedRole });
  }, [sortOrder, sortColumn, selectedRole]);

  useEffect(() => {
    dispatch(fetchCountData())
      .then((res) => {
        setUserCount(res?.data)
      })

  }, []);

  const underscoreToStpare = (str) => {
    if (str) {
      return str.replace(/_/g, " ");
    }
  }




  return (
    <>

      <div className="dashboard-outer">
        <div className="secion-title-wrap">
          <h1>80-IAC Dashboard</h1>
        </div>
        <div className="">
          <div className="row mb-40">
            <div className="col-12 col-lg-4">
              <div className="link-card-outer">
                <a href="/user-magement/userlist" className="inner-wrap">
                  <div className="img-wrap">
                    <img src={icon1} />
                  </div>
                  <div className="info-wrap">
                    <h5>Manage</h5>
                    <div className="sub-ttl-wrap">
                      <span>User</span>
                      <img src={linkIcon} class="link-arrow" width="25" />
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="link-card-outer">
                <a href="/edit-list" className="inner-wrap">
                  <div className="img-wrap">
                    <img src={icon2} />
                  </div>
                  <div className="info-wrap">
                    <h5>Manager</h5>
                    <div className="sub-ttl-wrap">
                      <span>Profile</span>
                      <img src={linkIcon} class="link-arrow" width="25" />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>




          <div class="row mb-50 mb-bottom-30">
            <div class="col-12 col-lg-12 mb-bottom-30">
              <div class="stat-block-wrap">
                <div class="stat-header">
                  <h5>80-IAC Application</h5>
                </div>
                <div class="stat-body clearfix">
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.totalCount}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>TOTAL COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[0].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[0].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[2].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[2].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[6].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[6].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[8].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[8].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[1].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[1].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[5].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[5].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[4].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[4].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[3].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[3].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[7].count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[7].status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[9]?.count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[9]?.status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[10]?.count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[10]?.status)} COUNT</h6>
                    </div>
                  </div>
                  <div class="inner-stat-row clearfix">
                    <div class="count-wrap">
                      <span>{userCount?.statuses?.[11]?.count}</span>
                    </div>
                    <div class="title-wrap">
                      <h6>{underscoreToStpare(userCount?.statuses?.[11]?.status)} COUNT</h6>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
    // <div className="table-wrap">

    //   <SearchBoxForUser option={FilterOption} doSearch={(e) => setSelectedRole(e)} />
    //   <Table
    //     dataTable={users}
    //     columns={columns({userRole,page:'80IAC'})}
    //     keyField='username'
    //     onSortChange={onSortChange}
    //     sizePerPage={1000}

    //   />
    // </div>
  );
};

UserList.propTypes = {
  getUserList: PropTypes.func,
  users: PropTypes.arrayOf(PropTypes.object),
};

UserList.defaultProps = {
  getUserList: () => { },
  users: [],
};

const mapStateToProps = (state) => {
  return {
    users: state.userList.userData.data,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        getUserList,
      },
      dispatch
    ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserList);
